var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 53,
    viewBox: "0 0 79 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3958_1268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.525 7.80603H72.475C74.0729 7.80603 75.6054 8.44081 76.7353 9.57071C77.8652 10.7006 78.5 12.2331 78.5 13.831V45.974C78.5 46.7652 78.3442 47.5487 78.0414 48.2797C77.7386 49.0107 77.2948 49.6749 76.7353 50.2343C76.1758 50.7938 75.5117 51.2376 74.7807 51.5404C74.0497 51.8432 73.2662 51.999 72.475 51.999H6.524C4.92634 51.999 3.39411 51.3644 2.26439 50.2346C1.13467 49.1049 0.5 47.5727 0.5 45.975L0.5 13.831C0.5 12.2331 1.13478 10.7006 2.26468 9.57071C3.39459 8.44081 4.92707 7.80603 6.525 7.80603Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.525 7.30603H72.475C74.205 7.30788 75.8635 7.99593 77.0868 9.21921C78.3101 10.4425 78.9981 12.1011 79 13.831V45.974C78.9981 47.704 78.3101 49.3626 77.0868 50.5859C75.8635 51.8091 74.205 52.4972 72.475 52.499H6.524C4.7943 52.4972 3.13597 51.8092 1.91288 50.5861C0.689796 49.3631 0.00185292 47.7047 0 45.975V13.831C0.00185293 12.1011 0.689901 10.4425 1.91317 9.21921C3.13645 7.99593 4.79503 7.30788 6.525 7.30603ZM72.475 51.499C73.9398 51.4974 75.3442 50.9148 76.38 49.879C77.4158 48.8432 77.9984 47.4389 78 45.974V13.831C77.9984 12.3662 77.4158 10.9618 76.38 9.92602C75.3442 8.89023 73.9398 8.30762 72.475 8.30603H6.525C5.06017 8.30762 3.65578 8.89023 2.61999 9.92602C1.58419 10.9618 1.00159 12.3662 1 13.831V45.975C1.00159 47.4396 1.58409 48.8437 2.6197 49.8793C3.6553 50.9149 5.05943 51.4974 6.524 51.499H72.475Z",
    fill: "#189D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2741 7.806H26.7241L28.1241 0H50.8741L52.2741 7.806Z",
    fill: "#189D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5284 12.383H59.6494V16.988H70.5284V12.383Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3464 12.383H59.6494V16.988H60.3464V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8015 12.383H61.1045V16.988H61.8015V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2556 12.383H62.5586V16.988H63.2556V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7107 12.383H64.0127V16.988H64.7107V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1648 12.383H65.4678V16.988H66.1648V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6189 12.383H66.9219V16.988H67.6189V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.074 12.383H68.377V16.988H69.074V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.529 12.383H69.832V16.988H70.529V12.383Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.929 3.47498H44.792C45.2866 3.47498 45.761 3.67147 46.1107 4.02122C46.4605 4.37098 46.657 4.84535 46.657 5.33998V9.04698C46.657 9.54081 46.4608 10.0144 46.1116 10.3636C45.7624 10.7128 45.2888 10.909 44.795 10.909H34.926C34.4321 10.909 33.9585 10.7128 33.6093 10.3636C33.2601 10.0144 33.064 9.54081 33.064 9.04698V5.33998C33.064 4.84535 33.2605 4.37098 33.6102 4.02122C33.96 3.67147 34.4343 3.47498 34.929 3.47498Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1231 8.82796C45.1223 9.06243 45.0289 9.28708 44.8631 9.45288C44.6973 9.61868 44.4726 9.71217 44.2381 9.71296H35.4841C35.2496 9.71217 35.0248 9.61871 34.8589 9.45294C34.6929 9.28717 34.5992 9.06253 34.5981 8.82796V5.55396C34.5992 5.31958 34.693 5.09515 34.859 4.9297C35.025 4.76424 35.2497 4.67122 35.4841 4.67096H44.2381C44.4724 4.67122 44.6971 4.76428 44.8629 4.92976C45.0288 5.09524 45.1223 5.31967 45.1231 5.55396V8.82796Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 17.993H0.5V44.243H78.5V17.993Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06702 21.493H0.5V40.743H7.06702C8.17987 40.7396 9.24617 40.296 10.0331 39.509C10.82 38.7221 11.2636 37.6558 11.267 36.543V25.693C11.2636 24.5801 10.82 23.5138 10.0331 22.7269C9.24617 21.94 8.17987 21.4964 7.06702 21.493Z",
    fill: "#189D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.824 21.493H78.391V40.743H71.824C70.7112 40.7396 69.6449 40.296 68.8579 39.509C68.071 38.7221 67.6275 37.6558 67.624 36.543V25.693C67.6272 24.58 68.0707 23.5136 68.8577 22.7266C69.6446 21.9397 70.7111 21.4961 71.824 21.493Z",
    fill: "#189D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6518 49.087C49.3377 49.087 57.1898 41.235 57.1898 31.549C57.1898 21.863 49.3377 14.011 39.6518 14.011C29.9658 14.011 22.1138 21.863 22.1138 31.549C22.1138 41.235 29.9658 49.087 39.6518 49.087Z",
    fill: "#B2E7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2707 31.549C53.2707 34.2424 52.472 36.8753 50.9756 39.1147C49.4793 41.3542 47.3524 43.0996 44.8641 44.1304C42.3757 45.1611 39.6376 45.4308 36.9959 44.9053C34.3543 44.3799 31.9278 43.0829 30.0233 41.1784C28.1188 39.2738 26.8218 36.8473 26.2963 34.2057C25.7709 31.5641 26.0406 28.826 27.0713 26.3376C28.102 23.8492 29.8475 21.7224 32.0869 20.226C34.3264 18.7297 36.9593 17.931 39.6527 17.931C43.2644 17.931 46.7282 19.3657 49.2821 21.9196C51.8359 24.4735 53.2707 27.9373 53.2707 31.549Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6517 43.772C46.4023 43.772 51.8747 38.2996 51.8747 31.549C51.8747 24.7984 46.4023 19.326 39.6517 19.326C32.9011 19.326 27.4287 24.7984 27.4287 31.549C27.4287 38.2996 32.9011 43.772 39.6517 43.772Z",
    fill: "#1CA254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4756 31.549C50.4756 33.6895 49.8408 35.7821 48.6516 37.5619C47.4623 39.3417 45.772 40.7289 43.7944 41.5481C41.8167 42.3673 39.6406 42.5816 37.5411 42.164C35.4417 41.7464 33.5132 40.7156 31.9996 39.202C30.486 37.6883 29.4552 35.7599 29.0376 33.6604C28.6199 31.561 28.8343 29.3848 29.6535 27.4072C30.4726 25.4295 31.8598 23.7392 33.6397 22.55C35.4195 21.3607 37.512 20.726 39.6526 20.726C41.0739 20.726 42.4813 21.0059 43.7944 21.5498C45.1075 22.0937 46.3006 22.8909 47.3056 23.8959C48.3106 24.9009 49.1078 26.0941 49.6517 27.4072C50.1957 28.7203 50.4756 30.1277 50.4756 31.549Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5915 31.548C44.5915 32.5252 44.3017 33.4805 43.7588 34.2931C43.2158 35.1056 42.4441 35.7389 41.5413 36.1129C40.6384 36.4869 39.645 36.5847 38.6865 36.3941C37.7281 36.2034 36.8477 35.7328 36.1567 35.0418C35.4656 34.3508 34.9951 33.4704 34.8044 32.5119C34.6138 31.5535 34.7116 30.56 35.0856 29.6572C35.4595 28.7543 36.0929 27.9826 36.9054 27.4397C37.7179 26.8968 38.6732 26.607 39.6505 26.607C40.9609 26.607 42.2177 27.1276 43.1443 28.0542C44.0709 28.9808 44.5915 30.2376 44.5915 31.548Z",
    fill: "#141923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9948 25.839C46.9948 26.3136 46.8541 26.7777 46.5904 27.1723C46.3266 27.567 45.9518 27.8746 45.5133 28.0563C45.0747 28.2379 44.5922 28.2855 44.1266 28.1928C43.6611 28.1002 43.2334 27.8717 42.8978 27.536C42.5621 27.2004 42.3335 26.7727 42.2409 26.3072C42.1483 25.8416 42.1959 25.3591 42.3775 24.9205C42.5592 24.482 42.8668 24.1072 43.2615 23.8434C43.6562 23.5797 44.1201 23.439 44.5948 23.439C45.2313 23.439 45.8418 23.6918 46.2919 24.1419C46.742 24.592 46.9948 25.2024 46.9948 25.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6031 30.776C47.7408 30.8821 47.8439 31.0267 47.8994 31.1914C47.955 31.3561 47.9604 31.5336 47.9151 31.7014C47.8698 31.8692 47.7757 32.0199 47.6448 32.1342C47.5139 32.2486 47.352 32.3216 47.1796 32.344C47.0072 32.3663 46.8321 32.3371 46.6763 32.2599C46.5206 32.1827 46.3912 32.0611 46.3045 31.9104C46.2178 31.7597 46.1778 31.5867 46.1895 31.4133C46.2011 31.2398 46.264 31.0737 46.3701 30.936C46.4405 30.8445 46.5283 30.7678 46.6284 30.7103C46.7284 30.6527 46.8389 30.6154 46.9534 30.6006C47.0679 30.5857 47.1842 30.5936 47.2957 30.6237C47.4072 30.6538 47.5116 30.7055 47.6031 30.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6162 4.53296H57.4092V7.87596H70.6162V4.53296Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3096 4.43298H70.7166V7.97598H57.3096V4.43298ZM70.5166 4.63298H57.5096V7.77598H70.5166V4.63298Z",
    fill: "#1CA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1699 5.21698H58.3799V7.19198H59.1699V5.21698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.917 5.21698H60.127V7.19198H60.917V5.21698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6631 5.21698H61.8711V7.19198H62.6631V5.21698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4102 5.21698H63.6182V7.19198H64.4102V5.21698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1563 5.21698H65.3643V7.19198H66.1563V5.21698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9013 5.21698H67.1113V7.19198H67.9013V5.21698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6474 5.21698H68.8574V7.19198H69.6474V5.21698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3439 5.21698H12.8999V7.87598H21.3439V5.21698Z",
    fill: "#26B963"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3958_1268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 52.499,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraicon);
export default __webpack_public_path__ + "static/media/cameraicon.f3bcf48c59f0ccb712caa6b464add123.svg";
export { ForwardRef as ReactComponent };